/*@flow*/
import options from './options';
import mixin from './mixin';
import decompose from './decompose';

export default function withOptions(fn: any) {
  fn.dup = function() {
    const { unrefinedType } = decompose(fn);
    const temp = unrefinedType.bind({});
    if (!Object.prototype.hasOwnProperty.call(temp, 'name')) {
      Object.defineProperty(temp, 'name', {
        writable: true,
        value: fn.name,
        configurable: true,
      });
    }
    // TODO: test
    mixin(temp, this);
    // TODO: test
    temp.prototype = fn.prototype;
    temp.prototype.constructor = temp;
    return temp;
  };

  fn.options = function<T: {}>(o: T) {
    return options<*, T, *>(this.dup(), o);
  };

  fn.err = function(fn2: Function) {
    const v = this.dup();
    v.getValidationErrorMessage = fn2;
    return v;
  };

  fn.opt = fn.options;
}
